export const SELECTED_WORKFLOW_COOKIE_KEY = 'selected-workflow';

export const WORKFLOW_DEFAULT = 'PUBLISHED';
